import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/galleryPictures/Abstraktus1_w.jpg'
import _imports_1 from '../assets/galleryPictures/ComingToAnEnd2_b_w.jpg'
import _imports_2 from '../assets/galleryPictures/Okdelisch_w.jpg'
import _imports_3 from '../assets/galleryPictures/P1060352.jpg'
import _imports_4 from '../assets/galleryPictures/WhatRemains_w.jpg'
import _imports_5 from '../assets/galleryPictures/Bischl_k_w.jpg'
import _imports_6 from '../assets/galleryPictures/P1060371.jpg'
import _imports_7 from '../assets/galleryPictures/friedvollerFuchs_k_w.jpg'
import _imports_8 from '../assets/galleryPictures/Bienendrache_bw.jpg'
import _imports_9 from '../assets/galleryPictures/Gejagt_w.jpg'


const _hoisted_1 = { class: "scroll_wrapper" }
const _hoisted_2 = { class: "main_part" }
const _hoisted_3 = { class: "middle_part" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"left_images\" data-v-b04cd7d2><img src=\"" + _imports_0 + "\" class=\"first_left\" data-v-b04cd7d2><img src=\"" + _imports_1 + "\" class=\"second_left\" data-v-b04cd7d2><img src=\"" + _imports_2 + "\" class=\"third_left\" data-v-b04cd7d2><img src=\"" + _imports_3 + "\" class=\"forth_left\" data-v-b04cd7d2><img src=\"" + _imports_4 + "\" class=\"fiveth_left\" data-v-b04cd7d2></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "aw_heading" }, "Anika Wagner", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "intro_text" }, "Willkommen in meiner Kunstwelt.", -1)),
        _createVNode(_component_router_link, {
          to: "/galerie",
          class: "gallery_link_button button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.activeNav = '0';})
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "gallery_link" }, "Eintreten", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("img", {
          src: require('@/assets/AW1.svg'),
          alt: "AW in gemalten Farben",
          class: "aw_symbol"
        }, null, 8, _hoisted_4)
      ]),
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"right_images\" data-v-b04cd7d2><img src=\"" + _imports_5 + "\" class=\"first_right\" data-v-b04cd7d2><img src=\"" + _imports_6 + "\" class=\"second_right\" data-v-b04cd7d2><img src=\"" + _imports_7 + "\" class=\"third_right\" data-v-b04cd7d2><img src=\"" + _imports_8 + "\" class=\"forth_right\" data-v-b04cd7d2><img src=\"" + _imports_9 + "\" class=\"fiveth_right\" data-v-b04cd7d2></div>", 1))
    ])
  ]))
}